import { render, staticRenderFns } from "./sort-group-value-modal.vue?vue&type=template&id=1b87fdb2"
import script from "./sort-group-value-modal.vue?vue&type=script&lang=js"
export * from "./sort-group-value-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports